// extracted by mini-css-extract-plugin
module.exports = {"mobileHeight":"screen and (max-height: 824px)","root":"AutocompleteResults_root__2rggb","empty":"AutocompleteResults_empty__13o-2","spinner":"AutocompleteResults_spinner__3su5Q"};